<script>
    import { spaLink } from "../actions"
    import TopButton from "./TopButton.svelte"
</script>

<TopButton />

<footer>
    <div class="copy">
        <div class="container tp-m bp-m">
            <div class="grid align-center">
                <div class="col-md-6">
                    <div class="grid align-center gap-m">
                        <div class="col">&copy; {new Date().getFullYear()} SPORTident GmbH</div>
                        <!-- current year oder immer 2024 -->
                        <nav class="col-auto footer-nav">
                            <!-- Als Menü anlegen -->
                            <a use:spaLink href="/legal-information">Legal Information</a>
                        </nav>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="grid">
                        <div class="col-auto">
                            <img src="/assets/img/madein.jpg" alt="made in Germany" />
                        </div>
                        <div class="col-auto">
                            <div class="grid align-center">
                                <div class="col">Follow us on</div>
                                <nav class="col-auto social-nav">
                                    <!-- als Menü anlegen mit Auswahl Link und Netzwerk? -->
                                    <a href="https://www.facebook.com/sportident/" target="_blank"
                                        ><img src="/assets/icons/lucide_facebook.svg" alt="facebook" /></a
                                    >
                                    <a href="https://www.instagram.com/sportident.de/" target="_blank"
                                        ><img src="/assets/icons/lucide_instagram.svg" alt="instagram" /></a
                                    >
                                    <a href="https://www.youtube.com/user/sportidentrun" target="_blank"
                                        ><img src="/assets/icons/lucide_youtube.svg" alt="youtube" /></a
                                    >
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
